import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { SecurityProfileEnum } from '../enums/securityProfile.enum';

/**
 * Data-residency Phase 4: single decision point for whether the current user sees
 * the corporate (cross-region, PII-redacted) reporting surface, or keeps querying
 * their own regional cell (today's behaviour).
 *
 * The signal is the server-set `residency` block on the identity (never
 * client-supplied). While `residency.enabled` is false — the default on every
 * current deployment — this is always false and nothing corporate is shown or
 * fetched. The backend additionally enforces the AdminOrSuperAdmin policy on the
 * corporate endpoints; this check mirrors it so the UI never surfaces a view the
 * API would reject.
 */
@Injectable({ providedIn: 'root' })
export class ReportingScopeService {
    constructor(private authService: AuthService) {}

    get canAccessCorporateReporting(): boolean {
        const user = this.authService.getCurrentUser();
        const residency = user?.residency;
        if (!residency?.enabled || !residency.isCorporateHost) return false;
        return user.userType === SecurityProfileEnum.Admin
            || user.userType === SecurityProfileEnum.SuperAdmin;
    }

    get homeRegionCode(): string {
        return this.authService.getCurrentUser()?.residency?.regionCode ?? '';
    }
}
